
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/employees/bulk",
      function () {
        return require("private-next-pages/employees/bulk.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/employees/bulk"])
      });
    }
  